"use client";

import React from "react";
import { ArrowRight, Scissors } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const specialties = [{
  title: "Premium Fade",
  description: "De strakste overloop en messcherpe contouren. Als dé barber in Middelharnis zorgen wij voor een look die perfect bij jou past.",
  price: "Vanaf €28,-",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577285/img/hekappers_1714029303_3353843629535888124_7128222511_1.jpg",
  link: "https://salonkee.nl/salon/he-kappers"
}, {
  title: "Baardstyling",
  description: "Professioneel trimmen en modelleren voor de perfecte baard. Hoogwaardige verzorging bij jouw herenkapper op Goeree-Overflakkee.",
  price: "Vanaf €18,-",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577285/img/beard_trimming_barber.png",
  link: "https://salonkee.nl/salon/he-kappers"
}, {
  title: "Hot Towel Scheerbeurt",
  description: "Beleef de ultieme ontspanning met een klassieke scheerbeurt. Traditioneel vakmanschap en luxe verzorging voor een glad resultaat.",
  price: "Vanaf €25,-",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577285/img/hot_towel_shave_treatment.png",
  link: "https://salonkee.nl/salon/he-kappers"
}];
export default function OurSpecialties() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="80670" id="onze-barbiers-expertise" className="dark bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />
      
      <div className="container mx-auto px-4 md:px-6">
        <div ref={headerRef} className={`flex flex-col items-center text-center mb-16 transition-all duration-1000 transform ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="inline-flex items-center justify-center p-2 bg-primary/20 rounded-lg mb-4">
            <Scissors className="h-5 w-5 text-primary" />
          </div>
          <h2 className="font-sans text-3xl md:text-5xl font-bold tracking-wider mb-4 uppercase">
            Onze <span className="text-primary">Expertise</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl text-lg font-sans">
            Bij H&E Kappers in Middelharnis combineren we jarenlange ervaring met de nieuwste trends. 
            Ontdek onze specialiteiten voor de moderne heer.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 delay-200 transform ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {specialties.map((item, i) => <div data-index={i} key={i} className="h-full">
              <Card className="group relative h-[420px] w-full overflow-hidden rounded-xl border-border/40 bg-transparent p-0 transition-all duration-500 hover:border-primary hover:shadow-[0_0_30px_rgba(212,175,55,0.2)]">
                {}
                <div className="absolute inset-0 z-0 overflow-hidden">
                  <img src={item.image} alt={item.title} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                </div>

                {}
                <div className="absolute inset-0 z-10 bg-gradient-to-t from-background via-background/80 to-transparent transition-opacity duration-500 group-hover:opacity-95" />

                {}
                <CardContent className="relative z-20 flex h-full flex-col justify-end p-8">
                  <h3 className="font-sans text-2xl font-bold text-foreground mb-3 transition-colors duration-300 group-hover:text-primary uppercase">
                    {item.title}
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed mb-6 font-sans">
                    {item.description}
                  </p>
                  
                  <div className="mt-auto flex items-end justify-between pt-4 border-t border-border/30">
                    <Button variant="link" className="p-0 h-auto text-foreground hover:text-primary transition-colors font-sans font-semibold" asChild>
                      <Link to={item.link}>
                        Afspraak maken <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                      </Link>
                    </Button>
                    <span className="font-sans text-sm font-bold text-primary transition-colors duration-300">
                      {item.price}
                    </span>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>

        <div className="mt-16 flex justify-center">
          <Button size="lg" className="font-sans font-bold tracking-widest uppercase rounded-sm px-8" asChild>
            <Link to="/RatesPage">Bekijk alle prijzen</Link>
          </Button>
        </div>
      </div>
    </section>;
}